import { __cFocCampaignService } from '@/services/client/__c.foc-campaign.service'
import { useMutation } from '@tanstack/react-query'

export const useCampaignRegisterMutation = () => {
  return useMutation({
    mutationKey: ['mutation.foc-campaign-register'],
    mutationFn: __cFocCampaignService.registerCampaign,
  })
}
